import { useCallback } from 'react';
import debounce from 'lodash.debounce';

export const useDebounceCallback = <TFn extends (...args: TFnArgs[]) => TFnRes, TFnArgs extends any = any, TFnRes extends any = any> (
  callback: TFn,
  delay: number = 0,
) => {
  return useCallback(debounce(callback, delay), []);
};
